import React from 'react';
import { motion } from 'framer-motion';
import { ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';

const PrivacyPolicy = () => {
  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <div className="bg-[var(--bg-section)] py-8">
        <div className="container">
          <Link
            to="/"
            className="inline-flex items-center gap-2 text-[var(--text-secondary)] hover:text-[var(--text-primary)] transition-colors mb-6"
          >
            <ArrowLeft className="w-4 h-4" />
            Back to Home
          </Link>
          <h1 className="heading-2">Privacy Policy</h1>
          <p className="text-[var(--text-secondary)] mt-2">Last updated: January 2025</p>
        </div>
      </div>

      {/* Content */}
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        className="container py-12 max-w-4xl"
      >
        <div className="prose prose-lg max-w-none">
          <section className="mb-8">
            <h2 className="heading-3 mb-4">1. Introduction</h2>
            <p className="text-[var(--text-body)] leading-relaxed mb-4">
              Happiness in Action ("we", "our", or "us") is committed to protecting your privacy. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you visit our website or use our services.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="heading-3 mb-4">2. Information We Collect</h2>
            <p className="text-[var(--text-body)] leading-relaxed mb-4">
              We may collect information about you in various ways, including:
            </p>
            <ul className="list-disc pl-6 text-[var(--text-body)] space-y-2 mb-4">
              <li><strong>Personal Data:</strong> Name, email address, phone number, and other contact details you provide through our contact form.</li>
              <li><strong>Usage Data:</strong> Information about how you use our website, including pages visited and time spent.</li>
              <li><strong>Device Data:</strong> Browser type, operating system, and device identifiers.</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="heading-3 mb-4">3. How We Use Your Information</h2>
            <p className="text-[var(--text-body)] leading-relaxed mb-4">
              We use the information we collect to:
            </p>
            <ul className="list-disc pl-6 text-[var(--text-body)] space-y-2 mb-4">
              <li>Respond to your enquiries and provide customer support</li>
              <li>Send you information about our services (with your consent)</li>
              <li>Improve our website and services</li>
              <li>Comply with legal obligations</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="heading-3 mb-4">4. Data Sharing</h2>
            <p className="text-[var(--text-body)] leading-relaxed mb-4">
              We do not sell your personal information. We may share your data with trusted third-party service providers who assist us in operating our website and conducting our business, subject to confidentiality agreements.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="heading-3 mb-4">5. Your Rights (GDPR)</h2>
            <p className="text-[var(--text-body)] leading-relaxed mb-4">
              Under UK GDPR, you have the right to:
            </p>
            <ul className="list-disc pl-6 text-[var(--text-body)] space-y-2 mb-4">
              <li>Access your personal data</li>
              <li>Rectify inaccurate data</li>
              <li>Request erasure of your data</li>
              <li>Restrict or object to processing</li>
              <li>Data portability</li>
              <li>Withdraw consent at any time</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="heading-3 mb-4">6. Cookies</h2>
            <p className="text-[var(--text-body)] leading-relaxed mb-4">
              We use cookies to enhance your experience on our website. You can control cookie preferences through your browser settings. For more details, see our cookie consent banner.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="heading-3 mb-4">7. Contact Us</h2>
            <p className="text-[var(--text-body)] leading-relaxed mb-4">
              If you have questions about this Privacy Policy or wish to exercise your rights, please contact us at:
            </p>
            <p className="text-[var(--text-body)]">
              <strong>Email:</strong> don@happinessinaction.co<br />
              <strong>Phone:</strong> +44 333 011 7974
            </p>
          </section>
        </div>
      </motion.div>
    </div>
  );
};

export default PrivacyPolicy;
